module.exports = __webpack_public_path__ + "771ae6b07dcc4b1382c1cb0389249a75.svg";